import { FacilityEventType, Lane, TargetType, TurnType } from "@app/shared";
import { PointCloudSpherical } from './PointCloudSpherical';

// Vector3
interface Vector3 {
    x: number;
    y: number;
    z: number;
}

// TargetHistory
export interface TrackedTargetHistory {
    id?: string;
    targetId: string;
    frameNumber: number;
    date?: string;
    status?: number;
    lanes?: any; // null in your data
    width?: number;
    height?: number;
    length?: number;
    pointCount: number;
    position: Vector3;
    velocity: Vector3;
    acceleration: Vector3;
}

interface RectangleF {
    location: {
        isEmpty: boolean;
        x: number;
        y: number;
    };
    size: {
        isEmpty: boolean;
        width: number;
        height: number;
    };
    x: number;
    y: number;
    width: number;
    height: number;
    left: number;
    top: number;
    right: number;
    bottom: number;
    isEmpty: boolean;
}

export enum TargetSource {
    Unknown = 0,
    Radar = 1,
    Camera = 2
}

enum DeviceTargetStatus { Unknown = 0, New, Active, Static, Lost, Offsite }

export interface DetectedEvent {
    id: string;
    deviceId: string;
    target: TrackedTarget;
    secondaryTarget?: TrackedTarget | null;
    screenLineId?: string | null;
    detectionZoneId?: string | null;
    dateCreated: string;
    eventType: FacilityEventType;
    eventValue: number;
    eventValue2?: number | null;
    attachmentUrl?: string | null;
    shouldSendToServer: boolean;

}

export interface TrackedTarget {
    listIndex?: number; //Add this to store the index of this in our sim targets (for the visualier)
    firstVideoFrameTracked?: number; //Add this to store the first video frame for sorting our sim / result targets

    trackedDurationMs?: number;
    firstFrameTracked: number;
    lastFrameTracked: number;
    lastUpdateUTCTicks?: number;
    currentStateStarted?: string;
    lastUpdate?: string;
    radarId: number;
    targetId: string;
    position: Vector3;
    velocity: Vector3;
    acceleration: Vector3;
    targetHistory: TrackedTargetHistory[];
    maxLength?: number;
    maxWidth?: number;
    hasPhoto: boolean;
    cameraBoundingBox?: RectangleF;
    laneNumber?: Lane;
    turn?: TurnType;
    source: TargetSource;
    lastUpdateSent?: string;
    lastEventCheck?: string;
    numAssociations?: number;
    currentState?: DeviceTargetStatus;

    // Classification fields
    predictionConfidence?: number;
    associatedCameraTarget?: TrackedTarget | null;
    numTrailerAssociations?: number;
    pointCount?: number;
    maxPointCount?: number | null;
    maxVolume?: number;
    associatedPoints?: PointCloudSpherical[] | undefined;
    events: DetectedEvent[];
    velocityFromPositionHistory?: Vector3 | null;
    positionOffset?: Vector3 | null;
    reportWidth?: number;
    reportLength?: number;
    reportHeight?: number;
    reportedType: TargetType;
    fusedType?: TargetType;
    predictedType?: TargetType;
    classifierConfidenceDict?: any;
    fhwaType?: number | null;
    totalNumWheels?: number | null;
}

